import type { FunctionComponent } from "react";

import { Tabs, Tab } from "@similarweb/ui-components";

import { i18nFilter } from "app/filters/i18nFilter";
import { ELandingPagesTabs } from "app/common/keyword-research/landing-pages/landingPagesTypes";
import { isPaidSearchPagesAvailable } from "app/pages/keyword-research/utils/permissions";
import { useSelectedPageTab } from "app/custom-hooks/useSelectedPageTab";
import { OrganicLandingPagesV2 } from "app/pages/keyword-research/website-analysis/pages/landing-pages/OrganicLandingPagesV2";
import { TabListStyled } from "app/components/keyword-research/landing-pages/styledComponents";
import { proNavigator } from "single-spa/react-app/ProNavigator";
import { allTrackers } from "app/services/track/track";

export const LandingPagesV2: FunctionComponent = () => {
    const i18n = i18nFilter();

    const { selectedPageTabIndex, setSelectedPageTabIndex } = useSelectedPageTab(ELandingPagesTabs);

    const onPageTabSelect = (index: ELandingPagesTabs) => {
        if (index === selectedPageTabIndex) {
            return;
        }
        const selectedTabKey = ELandingPagesTabs[index];
        setSelectedPageTabIndex(index);
        void proNavigator.updateParams({ selectedPageTab: selectedTabKey });
        allTrackers.dispatchTrackEvent("Tab", "click", `Change page tab/${selectedTabKey || ""}`);
    };

    return (
        <Tabs
            onSelect={onPageTabSelect}
            selectedIndex={selectedPageTabIndex}
        >
            <TabListStyled size={"lg"}>
                <Tab id={ELandingPagesTabs.Organic}>{i18n("organic.landing.pages.tab.organic")}</Tab>
                {isPaidSearchPagesAvailable() ? (
                    <Tab
                        id={ELandingPagesTabs.Paid}
                        data-automation-item="paid"
                    >
                        {i18n("organic.landing.pages.tab.paid")}
                    </Tab>
                ) : null}
            </TabListStyled>
            <OrganicLandingPagesV2 />
        </Tabs>
    );
};
